export default __webpack_public_path__ + "static/media/wanna3.c6aa2307.png";